import { useSeoMeta } from '@unhead/react';
import { Layout } from '@/components/Layout';
import { TodaysMass } from '@/components/TodaysMass';

const Index = () => {
  useSeoMeta({
    title: 'Nostr Missal — Daily Roman Missal',
    description: 'A free, open-access digital Daily Roman Missal for the Novus Ordo, with the complete liturgical calendar, daily Mass readings, and Order of Mass. Built on Nostr.',
    ogType: 'website',
    ogTitle: 'Daily Roman Missal',
    ogDescription: 'A free, open-access digital Daily Roman Missal for the Novus Ordo, with the complete liturgical calendar, daily Mass readings, and Order of Mass. Built on Nostr.',
    ogImage: 'https://daily-roman-missal.shakespeare.wtf/og-image.svg',
    ogImageWidth: '1200',
    ogImageHeight: '630',
    ogUrl: 'https://daily-roman-missal.shakespeare.wtf/',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Daily Roman Missal',
    twitterDescription: 'A free, open-access digital Daily Roman Missal for the Novus Ordo, with the complete liturgical calendar, daily Mass readings, and Order of Mass. Built on Nostr.',
    twitterImage: 'https://daily-roman-missal.shakespeare.wtf/og-image.svg',
  });

  return (
    <Layout>
      <TodaysMass />
    </Layout>
  );
};

export default Index;
